export default __webpack_public_path__ + "images/0xe896cdeaac9615145c0ca09c8cd5c25bced6384c.png";